<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="headers"
    :items="drops"
    :rows-per-page-items="[50]"
    class="elevation-1"
    hide-default-footer
  >
    <template v-slot:items="props">
      <td style="min-width: 120px;">{{ props.item.date }}</td>
      <td style="min-width: 120px;">{{ props.item.eduAttempt }}</td>
      <td style="min-width: 500px;">{{ props.item.message }}</td>
    </template>
  </v-data-table>
</template>


<script>
export default {
  name: "Drops",
  props: ["drops"],
  data () {
    return {
      headers: [
        {
          text: 'Дата',
          align: 'left',
          sortable: false,
          value: 'date',
        },
        {
          text: 'Попытка обучения',
          align: 'left',
          sortable: false,
          value: 'eduAttempt',
        },
        {
          text: 'Инфо',
          align: 'left',
          sortable: false,
          value: 'message',
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>
